import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb, { BreadcrumbWrapper } from '@/components/feature/Breadcrumb';
import { WebPageSchema, FAQPageSchema, OrganizationSchema } from '@/components/feature/SchemaOrg';

export default function AboutPage() {
  const teamMembers = [
    { name: '李明', role: '创始人 & CEO', bio: '十年互联网影视行业经验，致力于让每个人都享受到便捷的视频服务。' },
    { name: '王芳', role: '技术总监', bio: '前阿里巴巴高级工程师，专注视频流媒体技术研发。' },
    { name: '张强', role: '内容运营总监', bio: '资深影视内容策划人，拥有丰富的行业资源和敏锐的选片眼光。' },
    { name: '刘洋', role: '产品经理', bio: '专注于用户体验优化，打造极致的追剧观影平台。' },
  ];

  const testimonials = [
    { name: '赵先生', text: '嫩草视频真的太好用了！追剧必备，更新速度超快，画质也很棒。', rating: 5 },
    { name: '陈女士', text: '每天都在嫩草视频看剧，分类很清晰，找剧特别方便。推荐给了很多朋友。', rating: 5 },
    { name: '周同学', text: '学生党的福音！完全免费，不用花钱开会员就能看最新剧集。', rating: 5 },
    { name: '吴先生', text: '聚合了多个平台的资源，不用切换APP了，一个嫩草视频就够。', rating: 4 },
    { name: '黄女士', text: '画质清晰流畅，资源丰富，是我用过最好的免费视频平台。', rating: 5 },
    { name: '林先生', text: '更新真的很快，追的几部剧都是当天更新。推荐！', rating: 5 },
  ];

  const faqs = [
    {
      question: '嫩草视频是什么？',
      answer: '嫩草视频是一个影视聚合平台，整合了妖精视频、桃花视频、苹果视频、榴莲视频等多个主流视频平台的资源，为用户提供一站式高清在线观看服务。',
    },
    {
      question: '嫩草视频收费吗？',
      answer: '完全免费！嫩草视频致力于让每个人都能免费享受高质量的影视内容，无需任何付费。',
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 嫩草视频 | 品牌介绍、用户口碑与联系方式"
        description="了解嫩草视频的品牌故事和团队，查看千万用户真实评价。嫩草视频聚合妖精视频、桃花视频等平台热播影视剧，高清在线观看，完全免费。"
        keywords="嫩草视频,关于我们,品牌介绍,用户口碑,联系方式,免费视频"
        canonicalUrl="https://www.nencao.com/about"
      />
      <OrganizationSchema />
      <WebPageSchema
        title="关于我们 - 嫩草视频"
        description="了解嫩草视频的品牌故事和团队，查看千万用户真实评价。"
        url="https://www.nencao.com/about"
      />
      <FAQPageSchema questions={faqs} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <BreadcrumbWrapper>
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </BreadcrumbWrapper>

          <section className="py-12 md:py-16 bg-background-50">
            <div className="max-w-[1000px] mx-auto px-4 md:px-6">
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-6 text-center">关于嫩草视频</h1>
              <div className="text-foreground-600 leading-relaxed space-y-4 max-w-3xl mx-auto text-sm">
                <p>
                  <strong>嫩草视频</strong>成立于2023年，是一个聚合<strong>妖精视频</strong>、<strong>桃花视频</strong>、<strong>苹果视频</strong>、<strong>榴莲视频</strong>、<strong>豆花视频</strong>等平台热播影视资源的在线观影平台。
                </p>
                <p>
                  我们的使命是让每一位用户都能方便快捷地找到自己想看的影视内容，提供最新电视剧<strong>完整版</strong><strong>高清在线观看</strong>服务，<strong>电影大全</strong>每日更新，追剧不等待。
                </p>
                <p>
                  作为一个聚合平台，嫩草视频不生产内容，而是将全网最优质的影视资源整合在一起，用户无需在多个平台之间切换，即可享受一站式观影体验。
                </p>
                <p>
                  目前，嫩草视频已累计服务超过<strong>千万用户</strong>，日活跃用户达到百万级别，成为国内领先的视频聚合平台之一。我们持续优化产品体验，不断丰富内容资源，致力于成为用户追剧观影的首选平台。
                </p>
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-[1000px] mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">核心团队</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {teamMembers.map((member) => (
                  <div key={member.name} className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                    <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                      <span className="text-secondary-600 font-bold text-lg">{member.name[0]}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">{member.name}</h3>
                    <p className="text-xs text-primary-500 mb-2 font-medium">{member.role}</p>
                    <p className="text-xs text-foreground-600 leading-relaxed">{member.bio}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-background-50">
            <div className="max-w-[1000px] mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-4 text-center">用户口碑</h2>
              <p className="text-foreground-600 text-sm text-center mb-10">来自千万用户的真实评价</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {testimonials.map((t, i) => (
                  <div key={i} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                    <div className="flex items-center gap-0.5 mb-2">
                      {Array.from({ length: 5 }).map((_, starIdx) => (
                        <div key={starIdx} className="w-4 h-4 flex items-center justify-center">
                          <i className={`${starIdx < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'} text-sm`}></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-3">&ldquo;{t.text}&rdquo;</p>
                    <p className="text-xs text-foreground-500 font-medium">— {t.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-[800px] mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="flex flex-col items-center gap-3 p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">contact@nencao.com</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">客服电话</h3>
                  <p className="text-xs text-foreground-600">400-000-0000</p>
                </div>
                <div className="flex flex-col items-center gap-3 p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">公司地址</h3>
                  <p className="text-xs text-foreground-600">北京市朝阳区科技园区</p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}